import {
  select, call, put, takeEvery,
} from 'redux-saga/effects';
import api from 'linkia-api';

import {
  REQUEST_CLIENTIFY_FILTERS,
} from './action-types';

import {
  reqClientifyFiltersSucceeded,
  reqClientifyFiltersFailed,
} from './actions';


import { tokenSelector } from '../login/selectors';

function* actionClientifyFilters(action) {
  const token = yield select(tokenSelector);
  const {
    bindingObject,
  } = action;
  try {
    const data = yield call(api.clientify.getAllFiltered, {
      bindingObject, token,
    });
    yield put(reqClientifyFiltersSucceeded(data, bindingObject));
  } catch (e) {
    yield put(reqClientifyFiltersFailed());
  }
}

export default [
  takeEvery(REQUEST_CLIENTIFY_FILTERS, actionClientifyFilters),
];
